module.exports = __webpack_public_path__ + "static/media/sjjc.5efa7bb3.webm";